export default "__VITE_ASSET__CRVW$zbS__"